import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import LostItemAuditChanged from '../LostItem/LostItemAuditChanges';
import Modal from 'react-responsive-modal';

const { ExportCSVButton } = CSVExport;
const reportStyles= {
  modal: {
    top: '35%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width: '60%',
    transform: 'translate(-40%, -10%)'
  },
  greenText: {
    color: 'rgb(0,255,100)'
  },
  style3: {
    marginRight: '-25%'
  }
}

let lostItemColumns = [
  { dataField: 'itemNumber', sort: true,classes:'text-primary', text: 'Item#', filterable:true,  align: 'left' , headerStyle: (colum, colIndex) => {
    return { width: '50px', textAlign: 'center' };} 
   },
    { dataField: 'shortDescription', sort: true,classes:'text-primary', text: 'Item', filterable:true,  align: 'left' },
    { dataField: 'longDescription',sort: true, text: 'Description', classes:'text-primary',align: 'left'},
    { dataField: 'createdAt',sort: true,formatter: LostItemFunctions.formatDateTime,classes:'text-primary',  text: 'Created At',  },
    { dataField: 'updatedAt',sort: true,formatter: LostItemFunctions.formatDateTime,classes:'text-primary',  text: 'Modified At',  },
  
    { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime,classes:'text-primary',  text: 'Found',  },
  
    { dataField: 'modifiedBy',sort: true, text: 'Modified By', classes:'text-primary', align: 'left'},
    { dataField: 'id', hidden:true, text: 'Item', },
  ];
  const defaultSorted = [{
    dataField: 'updatedAt',
    order: 'desc'
  }];
  



  class LostItemAuditReport extends Component {
    constructor(props) {
      super(props);
        this.state = { 
            lostItems: [], 
            title:'',
            rowExpandStatus:'loading...',
            auditItems:[],
            displayAuditLog:false,
        }
        this._input = null;
        this.columns = [];
        
    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadLostItemData();
       
     
       }


    // Load the item history for the selected row int he list 
    addAsyncHistory=async (row)=>{
         console.log(row.id);
        this.setState({rowExpandStatus:'Loading...Please Wait'});
        try {
            axios.get(`${SERVER_URL}/Reports/lostItemAuditTrail`,{
               headers: { 
                 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                 'venueId' : auth0Client.getActiveVenuedId(),
                 'id' : row.id
               },
          
               
             
             }).then((res)=>{
               
               if (res.status === 401) {
                 //place your reentry code
                 console.log("Error" + res.status);
                
                }
       
               const auditItems = res.data.auditResults;
               console.log(auditItems);
               this.setState(
                   {
                    auditItems: auditItems,
                    rowExpandStatus:auditItems.length + ' returned'}
                    ); 
              
  
  
              });
          }catch(e){
              ToastStore.error('An error occured in the report.');
          }
       }
    



       loadLostItemData = () =>{
        try {
          axios.get(`${SERVER_URL}/Reports/LostItemAuditReport`,{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
           }).then((res)=>{
             
             if (res.status === 401) {
               //place your reentry code
               console.log("Error" + res.status);
              
              }
     
             const lostItems = res.data.recentLostItems;
          
             if (lostItems){
              
                this.setState({title: lostItems.length + ' items have been modified'})
             }else{
                this.setState({title: lostItems.length + ' No items returned'})
             }

             this.setState({
             
                lostItems : lostItems,
              });


            });
        }catch(e){
            ToastStore.error('An error occured in the report.');
        }
    }


    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        
      }

      
      displayAuditLogItems=async (row)=>{
        this.setState({
            lostItemId: row.id,
            displayAuditLog: true,
        })
      }
     
          
      renderLostItemGrid=()=>{
        const selectRow = {
            mode: 'radio',  // multi select
            bgColor: 'gray',
            onSelect: this.displayAuditLogItems.bind(this),
            hideSelectColumn: true,
            clickToExpand: true,
            clickToSelect: true,
           
           
          };

         
        
        if (this.state.lostItems.length === 0 ){
            return (
                "<p>no data logged yet</p>"
            )
        }
      
        return (
    
          <div >
           
           
           {this.renderToast()}
           {this.state.lostItems === null && <p>Loading lostItems...</p>}
            <ToolkitProvider 
            bootstrap4
              keyField='id' 
              data={ this.state.lostItems } 
              columns={ lostItemColumns }
             

              exportCSV
             
              >
              {
        props => (
          <div>
        
           <ExportCSVButton { ...props.csvProps }>Export CSV for Printing</ExportCSVButton>
           
        <hr />
            <BootstrapTable
              defaultSorted={defaultSorted}
              striped
              hover
             condensed
             selectRow={selectRow}
              { ...props.baseProps }
             
            />
          </div>
        )
      }</ToolkitProvider>
    
          </div>
    
    
        )
      }
        
      
    

    render(){
      // <LostItemAuditChanged  lostItemId={this.state.lostItemId}/>
        return(

            <div className="text-center" ref={c => (this._input = c)}> <h5> Audit Report : Lost Items Changes </h5>
            <h6>{LostItemFunctions.formatDate(Date())}</h6>
            <h6>{this.state.title}</h6>
              {this.renderToast()}
              {this.renderLostItemGrid()}
              <Modal style={reportStyles.modal}  scrollable={true} open={this.state.displayAuditLog} onClose={()=>this.setState({displayAuditLog:false})}  
              center>
             
             <LostItemAuditChanged  lostItemId={this.state.lostItemId}/>
                    
                    
                    
                   
              </Modal>
            </div>

        )



    }
}


export default withRouter(LostItemAuditReport);

